import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { storeAuthToken } from '../utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams((location.hash || '').replace(/^#/, ''));
    const sessionId = params.get('session_id');

    const query = new URLSearchParams(location.search);
    const target = query.get('target');

    if (!sessionId) {
      setError('Missing session_id');
      navigate('/auth', { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        storeAuthToken(res.data.token, true);
        localStorage.setItem('user', JSON.stringify(res.data.user));

        const role = res.data.role;
        if (target === 'dealer' && role !== 'dealer' && role !== 'super_admin') {
          toast.error("This Google account isn't linked to a dealer account.");
        }

        if (role === 'dealer' || role === 'super_admin' || res.data.dealer) {
          navigate('/dealer', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (e) {
        console.error('Google auth exchange failed', e);
        setError('Google sign-in failed');
        toast.error(e.response?.data?.detail || 'Google sign-in failed');
        navigate('/auth', { replace: true });
      }
    };

    exchange();
  }, [location.hash, location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="auth-callback">
      <div className="bg-white rounded-xl shadow p-6 w-full max-w-md text-center">
        <h1 className="text-xl font-bold text-[#004E86]" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Signing you in…
        </h1>
        <p className="text-sm text-gray-600 mt-2">
          {error ? error : 'Please wait while we finish your Google sign-in.'}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
